import { useTrackStore } from '@/stores/track';

// Same rule as isDangerSign on feature/TENG-990-detect-danger-sign; switch to it once that branch merges.
const isDangerSign = (name: string): boolean => String(name || '').toLowerCase().startsWith('ds_');

export function dangerSignConditionNames(): string[] {
  const trackStore = useTrackStore();
  if (!trackStore.dangerSignsEnabled) return [];

  return trackStore.conditions
    .map((condition: any) => condition.name)
    .filter(isDangerSign);
}
